import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactPaginate from 'react-paginate'
import { default as DataTableBasic } from 'react-data-table-component'
import { Card, Input, Button, Label, Row, Col, Container, DropdownToggle, Spinner, UncontrolledTooltip } from 'reactstrap'
import _ from "lodash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AngleDownSoildIcon, AngleRightSoildIcon } from "@csrc/assets/icons"
import { RefreshIcon, XIcon, CheckIcon, EllipsisVerticalIcon } from '@src/assets/icons'
import RegularCalendarRotateIcon from './RegularCalendarRotateIcon'
//************************************//
import '@styles/react/libs/tables/react-dataTable-component.scss'
import { trans, uuidv4, fetchQueryStringFromUrl, changeUrlQuery, convertParamsToQueryString, fetchKeysFromQueryString, setKeySessionStorage, getKeyFromSessionStorage, removeKeyFromSessionStorage, API, toLocalDateFormat } from '@utils'
import { getFilterSelectors, validateFilters, validateLimit, calculateMinWidth, customFetchKeysFromQueryStringCallbacks } from './Utils'

import HumanizeDate from '@src/components/HumanizeDate'
import ActionBar from '@src/components/action-bar'
import { saveQuery, deleteQuery } from '@src/redux/actions/datatable'
//************************************//
import NoDataFound from './NoDataFound'
import FilterForm from "./FilterForm"
import SelectColumns from "./SelectColumns"
import { _logWithFileContext } from '@csrc/utility/Utils'
//************************************//
export const ActionDropdownToggle = ({ disabled = false }) => {
  return (
    <DropdownToggle className="btn-icon" size="sm" color="flat-dark" disabled={disabled}>
      <FontAwesomeIcon size='lg' icon={EllipsisVerticalIcon} fixedWidth />
    </DropdownToggle>
  )
}
//************************************//
const columns = (cols, state, expandItemsInTreeView, expandAllItemsInTreeView, lastClickEvent) => {
  const columns = []
  if (!state.hideIndexing) {
    columns.push({
      name: '#',
      cell: (row, index) => ((state.page - 1) * state.limit) + index + 1,
      grow: 0,
      center: true,
      minWidth: '75px'
    })
  }
  _.map(cols, (c, k) => {
    // const c = {..._c, ...calculateMinWidth(_c, _c.name, _c.minWidth)}
    if (c.lastClick && c.cell) {
      const originalCell = c.cell
      c.cell = (row, index) => {
        return (
          <div onClick={lastClickEvent}>
            {originalCell(row, index)}
          </div>
        )
      }
    }
    if (c.translatable) {
      _.forEach(state.langArr, (lang, langK) => {
        if (state.langArr.includes(lang)) {
          const tc = { ...c }
          tc.name = (<span>{tc.name}<small className='text-lowercase text-muted'>{trans(`gen.lang.${lang}`)}</small></span>)
          tc.selector = `${tc.selector}.${lang}`
          columns.push(tc)
        }
      })
    } else {
      if (c.humanizeDate) {
        columns.push({
          ...c,
          wrap: true,
          grow: 0,
          width: state.humanizeDate ? c.width : '200px',
          minWidth: state.humanizeDate ? '170px' : '200px',
          format: (row, index) => {
            return state.humanizeDate
              ? row[c.selector] ? <HumanizeDate date={row[c.selector]} /> : '-'
              : row[c.selector] ? toLocalDateFormat(row[c.selector], 'LLL', true) : '-'
          }
        })
      } else if (c.boolean) {
        columns.push({
          ...c,
          wrap: false,
          grow: 0,
          center: true,
          format: (row, index) => {
            return _.get(row, c.selector) ? (
              <FontAwesomeIcon icon={CheckIcon} size={'lg'} className={'text-success'} />
            ) : (
              <FontAwesomeIcon icon={XIcon} size={'lg'} className={'text-danger'} />
            )
          }
        })
      } else if (state.treeView && state.expandableColumn === c.selector) {
        columns.push({
          ...c,
          wrap: true,
          name: <div className={'d-flex justify-content-center align-items-center'}>
            <Button size={'sm'} className={'btn-icon'} color={'flat-secondary'} onClick={(e) => {
              e.stopPropagation()
              expandAllItemsInTreeView()
              return true
            }}>
              <FontAwesomeIcon fontSize={14} icon={state.allExpanded ? AngleDownSoildIcon : AngleRightSoildIcon} />
            </Button>
            {c.name}
          </div>,
          cell: (row, index) => {
            return (
              <div
                className={'d-flex justify-content-center align-items-center'}
                style={{
                  paddingLeft: `${row.depth * 2.5}rem`
                }}>
                {row.children ?
                  !row.expanded ?
                    <Button size='sm' className='btn-icon mr-25' color='flat-secondary' onClick={() => expandItemsInTreeView(row)}>
                      <FontAwesomeIcon fontSize={14} icon={AngleRightSoildIcon} />
                    </Button>
                    :
                    <Button size='sm' className='btn-icon mr-25' color='flat-secondary' onClick={() => expandItemsInTreeView(row)}>
                      <FontAwesomeIcon fontSize={14} icon={AngleDownSoildIcon} />
                    </Button>
                  :
                  null
                }
                <span >
                  {_.get(row, c.selector)}
                </span>
              </div>
            )
          }
        })
      } else {
        const props = {}
        if (c.format) {
          props.format = (row, index) => {
            return c.format(row, index, { state })
          }
        }
        if (c.minWidth) {
          props.minWidth = _.isFunction(c.minWidth) ? c.minWidth({ state }) : c.minWidth
        }
        columns.push({
          ...c,
          ...props
        })
      }
    }
  })
  // Map string selectors to functions for react-data-table-component v7+
  return columns.map(col => {
    col.stringSelector = col.selector
    if (col.selector && _.isString(col.selector)) {
      const selectorPath = col.selector
      col.selector = row => _.get(row, selectorPath)
    }
    return col
  })
}
//************************************//
const fieldsColumns = (column, fields) => {
  const { dynamic, dynamicFieldVisibilityKey = 'fields', dynamicFieldVisibleByDefault = true, dynamicOptions } = column
  const { filedColName = 'fields' } = dynamicOptions
  // default -- applied to types: 'text', 'email', 'phone'
  return _.map(fields, (field) => {
    let columnProps = {
      show: true,
      sortable: true,
      minWidth: '200px',
      omit: true,
      showHide: true,
      filter: {
        enabled: true,
        type: 'textBuilder'
      }
    }

    if (_.includes(['integer', 'decimal'], field.field_type)) {
      columnProps = {
        ...columnProps,
        minWidth: '150px',
        filter: {
          enabled: true,
          type: 'numberBuilder'
        }
      }
    }

    if (_.includes(['textarea'], field.field_type)) {
      columnProps = {
        ...columnProps,
        sortable: false,
        omit: true,
        showHide: false,
        filter: {
          enabled: false
        }
      }
    }

    return {
      key: field.key,
      name: field.name,
      selector: `${filedColName}->${field.key}`,
      sortable: columnProps.sortable,
      omit: columnProps.omit,
      showHide: columnProps.showHide,
      grow: 0,
      minWidth: columnProps.minWidth,
      wrap: true,
      cell: (row) => {
        return _.get(row, `${filedColName}.${field.key}.value`)
      },
      filter: {
        enabled: columnProps.filter.enabled,
        type: columnProps.filter.type
      },
      dynamic,
      dynamicFieldVisibilityKey,
      dynamicFieldVisibleByDefault
    }
  })
}
//************************************//
const conditionalHideRowForTreeView = {
  when: row => row.hidden,
  style: {
    display: 'none'
  }
}
//************************************//
// See ./README.md#feature-map and ./README.md#activation-contract for the datatable feature contract.
class DataTable extends Component {
  constructor(props) {
    super(props)
    this.sessionStorage = props.sessionStorage ? _.toUpper(`DT_${props.sessionStorage}_HISTORY`) : false
    this.showHideSessionStorageName = props.sessionStorage ? _.toUpper(`DT_${props.sessionStorage}_COLUMNS`) : false
    this.switchModeSessionStorageName = props.sessionStorage ? _.toUpper(`DT_${props.sessionStorage}_MODE`) : false
    this.defaultLimit = props.limit ? props.limit : 25
    this.limitList = props.limitList || [10, 25, 50, 75, 100]
    this.defaultQueries = [{ key: 'default', name: "gen.datatable.default", queryString: "" }]
    this.state = {
      isBrowserAction: false,
      isInitialFilter: true,
      progressPending: true,
      disabled: false,
      data: [],
      total: 1,
      limit: this.defaultLimit,
      limitList: this.limitList,
      page: 1,
      totalPages: 1,
      filter: {},
      filterFormData: {},
      allSelectedByFilter: false,
      selectableRows: {},
      clearSelectableRows: false,
      bulkActions: this.props.bulkActions || null,
      bulkActionsByFilterEnabled: this.props.bulkActionsByFilterEnabled || false,
      defaultFilter: props.defaultFilter || {},
      forcedFilter: props.forcedFilter || {},
      hiddenFilter: props.hiddenFilter || [],
      sort: [],
      defaultFilterMode: props.defaultFilterMode ? props.defaultFilterMode : 'dropdown',
      hasFilter: props.hasFilter ? props.hasFilter : false,
      langArr: props.langArr,
      treeView: props.treeView,
      toolbar: props.toolbar ? {
        canChooseColumns: props.toolbar.canChooseColumns || false,
        canRefresh: props.toolbar.canRefresh || false,
        showHide: this._getInitShowHide(props.columns)
      } : false,
      expandableColumn: props.expandableColumn,
      allExpanded: !props.treeViewClosedByDefault,
      sessionStorageObject: this.sessionStorage ? this._getSessionStorageObject() : {},
      savedQueriesEnabled: this.sessionStorage && props.settingSavedQueriesEnabled && props.savedQueriesEnabled ? props.savedQueriesEnabled : false,
      lastClickKey: props.lastClickKey ? _.toUpper(`LAST_CLICK_${props.lastClickKey}`) : false,
      lastVisit: false,
      humanizeDate: true,
      clientSideMode: props.clientSideMode,
      pagination: props.pagination === undefined || props.pagination === null ? true : props.pagination,
      columns: _.map(props.columns, (column) => ({ ...column, stringSelector: column.selector })),
      columnsOrganizer: [],
      dynamicFieldsVisibility: {},
      columnsNumber: _.size(props.columns),
      hideIndexing: props.hideIndexing,
      noDataText: props.noDataText || null,
      createNewAction: props.createNewAction || null,
      pointerOnHover: props.pointerOnHover
    }

    this.ref = React.createRef(null)
    this._actionBarRef = React.createRef(null)
    this._refresh = this._refresh.bind(this)
  }
  //************************************//
  init() {
    const columnsOrganizerHasDynamicFieldsPending = _.find(this.state.columnsOrganizer, column => column.pending)
    if (columnsOrganizerHasDynamicFieldsPending) return
    const params = this._fetchKeysFromQueryString()
    const filter = validateFilters(this.state.columns, params.filter)
    const limit = validateLimit(this.limitList, params.limit, this.defaultLimit)
    this._fetchData({ ...params, limit, filter, filterFormData: filter })
  }
  //************************************//
  beforeInit(columns) {
    const hasColumnsDynamicField = _.filter(columns, (column) => column.dynamic)
    if (_.size(hasColumnsDynamicField) > 0) {
      this._prepareColumnsWithFetchDynamicFields(columns, this.init)
    } else {
      this.init()
    }
  }
  handlePopState = (event) => {
    this.setState({
      isBrowserAction: true,
      isInitialFilter: true,
      progressPending: true,
      filter: {},
      filterFormData: {},
      disabled: true,
      lastVisit: false,
      columns: this.props.columns,
      columnsOrganizer: [],
      dynamicFieldsVisibility: {},
      columnsNumber: _.size(this.props.columns)
    }, () => {
      this.beforeInit(this.state.columns)
    })
  };
  //************************************//
  componentDidMount() {
    this.beforeInit(this.state.columns)
    window.addEventListener("popstate", this.handlePopState)
  }
  componentWillUnmount() {
    window.removeEventListener("popstate", this.handlePopState)
  }
  //************************************//
  componentDidUpdate(prevProps, prevState) {
    this._reRenderColumnsWhenSomethingChangeFromProps()
    this._reRenderWhenColumnsNumberChange()
  }
  //************************************//
  _reRenderWhenColumnsNumberChange = () => {
    if (this.state.columnsNumber !== _.size(this.state.columns)) {
      this.setState({
        toolbar: this.props.toolbar ? {
          canChooseColumns: this.props.toolbar.canChooseColumns || false,
          canRefresh: this.props.toolbar.canRefresh || false,
          showHide: this._getInitShowHide(this.state.columns)
        } : false,
        columnsNumber: _.size(this.state.columns)
      })
    }
  }
  //************************************//
  // ADR reference: ./README.md#safe-stringify-columns
  // ADR decision link: ./README.md#adr--decisions
  _safeStringifyColumns = (columns) => {
    // Keep a WeakSet to track visited objects during serialization.
    const seen = new WeakSet()
    // Safely stringify columns with a replacer to handle React elements and circular references.
    return JSON.stringify(columns, (key, value) => {
      // If value is a React element, replace it with a readable token to avoid Fiber circular structures.
      if (React.isValidElement(value)) {
        // Use displayName, function name, or fallback string to identify the component type.
        return `[ReactElement:${value.type?.displayName || value.type?.name || String(value.type)}]`
      }
      // For any non-null object, detect circular references before returning it.
      if (typeof value === 'object' && value !== null) {
        // Return a marker when this object was already visited in the current traversal.
        if (seen.has(value)) return '[Circular]'
        // Record this object as visited so nested back-references can be detected.
        seen.add(value)
      }
      // Return primitive values and non-circular objects as-is.
      return value
    })
  }
  //************************************//
  _reRenderColumnsWhenSomethingChangeFromProps = () => {
    const propsColumnsWithoutDynamic = _.filter(this.props.columns, column => !column.dynamic)
    const stateColumnsWithoutDynamic = _.size(this.state.columnsOrganizer) === 0
      ? this.state.columns
      : _.flatten(_.map(_.filter(this.state.columnsOrganizer, column => !column.dynamic), columnOrganizer => columnOrganizer.columns))
    const toString = {
      propsColumnsWithoutDynamic: this._safeStringifyColumns(propsColumnsWithoutDynamic),
      stateColumnsWithoutDynamic: this._safeStringifyColumns(stateColumnsWithoutDynamic)
    }
    if (!_.isEqual(toString.propsColumnsWithoutDynamic, toString.stateColumnsWithoutDynamic)) {
      this.setState({
        columns: this.props.columns
      }, () => {
        this.beforeInit(this.state.columns)
      })
    }
  }
  //************************************//
  _prepareColumnsWithFetchDynamicFields = (columns, init) => {
    let columnsOrganizer = []
    _.forEach(columns, (column, index) => {
      if (column.dynamic) {
        this._fetchDynamicFields({ column, index }, (columnOrganizer, loading) => {
          if (loading) {
            columnsOrganizer = [...columnsOrganizer, columnOrganizer]
          } else {
            this.setState((state) => {
              const usedColumnsOrganizer = _.filter(state.columnsOrganizer, col => col.index !== index)
              const columnsOrganizer = _.orderBy([...usedColumnsOrganizer, columnOrganizer], 'index')
              const columns = _.flatten(_.map(columnsOrganizer, (object) => object.columns))
              return {
                columnsOrganizer,
                columns
              }
            }, init)
          }
        })
      } else {
        const columnOrganize = { index, columns: [column], pending: false }
        columnsOrganizer = [...columnsOrganizer, columnOrganize]
      }
    })

    this.setState({
      columnsOrganizer,
      columns: _.flatten(_.map(columnsOrganizer, (object) => object.columns))
    }, init)
  }
  //************************************//
  _checkDynamicFieldVisibility = (column) => {
    const columnKey = column.key || column.selector
    let visible = column?.dynamicFieldVisibleByDefault ?? true
    if (!_.isNil(column.dynamicFieldVisibilityKey) && _.size(_.get(this.state.dynamicFieldsVisibility, column.dynamicFieldVisibilityKey)) > 0) {
      visible = _.includes(_.get(this.state.dynamicFieldsVisibility, column.dynamicFieldVisibilityKey), columnKey)
    }
    if (!_.isNil(column.dynamicFieldVisibilityKey) && _.get(this.state.dynamicFieldsVisibility, column.dynamicFieldVisibilityKey) === false) {
      visible = false
    }
    return visible
  }
  //************************************//
  _fetchDynamicFields = ({ column, index }, stateCallback) => {
    const { fieldEndPoint } = column?.dynamicOptions
    if (fieldEndPoint) {
      stateCallback({ index, columns: [], pending: true, dynamic: `${fieldEndPoint}?${index}` }, true)
      API.get(fieldEndPoint).then(({ data: fields }) => {
        stateCallback({ index, columns: fieldsColumns(column, fields), pending: false, dynamic: `${fieldEndPoint}?${index}` }, false)
      })
    }
  }
  //************************************//
  _setSessionStorageObject = (object) => {
    if (!this.sessionStorage) return null
    const sessionStorageObject = this._getSessionStorageObject(object)
    setKeySessionStorage(this.sessionStorage, JSON.stringify(sessionStorageObject))
    return sessionStorageObject
  }
  //************************************//
  _getSessionStorageObject = (merge = {}) => {
    if (!this.sessionStorage) return null
    let sessionStorageObject = JSON.parse(getKeyFromSessionStorage(this.sessionStorage))
    if (!sessionStorageObject) {
      sessionStorageObject = { queries: {}, selected_key: 'default', queryString: '' }
    }
    return { ...sessionStorageObject, ...merge }
  }
  //************************************//
  _fetchData = (params = {}) => {
    const catchParam = { ...this.state, ...params }
    catchParam.withSavedQueries = !this.state.lastVisit && this.state.savedQueriesEnabled
    if (this.state.isInitialFilter) {
      catchParam.filter = catchParam.filterFormData = this._setInitialFilter(catchParam)
    }
    this.props._fetchData(catchParam, (data) => {
      const stateProps = {}
      if (this.state.lastVisit) {
        const queryString = changeUrlQuery(
          catchParam,
          ['limit', 'page', 'sort', 'filter'],
          this.props.browserHistory ? this.props.history : null
        )
        stateProps.sessionStorageObject = this._setSessionStorageObject({ queryString })
      } else {
        if (this.state.savedQueriesEnabled) {
          const selectedKey = _.get(this._setSessionStorageObject(), 'selected_key')
          const queryString = convertParamsToQueryString(
            catchParam,
            ['limit', 'page', 'sort', 'filter']
          )
          const _data = _.size(data?.saved_queries) > 0 ? {
            queries: _.mapValues(data.saved_queries, ({ id, key, name, query_string: queryString }) => ({ id, key, name, queryString }))
          } : {}
          stateProps.tableName = data.table_name
          stateProps.sessionStorageObject = this._setSessionStorageObject({ ..._data, queryString: queryString ? queryString : _.get(_data, `queries.${selectedKey}.queryString`, queryString) })
        }
      }
      let children = []
      this.setState({
        progressPending: false,
        disabled: false,
        data: this.state.treeView ? _.map(data.list, x => {
          const attrs = {}
          if (x.children) {
            children = [
              ...children,
              ...x.children
            ]
            attrs['expanded'] = this.state.allExpanded
          }
          attrs['hidden'] = !this.state.allExpanded && children.indexOf(x.id) > -1
          return {
            ...x,
            ...attrs
          }
        }) : data.list,
        total: data.pagination.total,
        limit: data.pagination.limit,
        page: data.pagination.current_page,
        totalPages: data.pagination.total_pages,
        filter: catchParam.filter,
        filterFormData: catchParam.filterFormData,
        // allExpanded: !this.props.treeViewClosedByDefault,
        lastVisit: true,
        ...stateProps
      }, () => {
        this._lastClickScroll()
      })
    })
  }
  //************************************//
  _lastClickEvent = (e) => {
    if (this.state.lastClickKey) {
      const row = e.target.closest('[role="row"]')
      setKeySessionStorage(this.state.lastClickKey, row.id)
    }
  }
  //************************************//
  _getInitShowHide = (columns) => {
    if (this.props.toolbar.canChooseColumns) {
      const showHideSessionStorage = getKeyFromSessionStorage(this.showHideSessionStorageName)
      let showHideJson = !_.isEmpty(showHideSessionStorage) && JSON.parse(showHideSessionStorage)
      showHideJson = !_.isEmpty(showHideJson) ? showHideJson : []
      return _.map(_.filter(columns, c => c.showHide), c => {
        const omit = _.find(showHideJson, x => x.selector === c.selector)?.omit
        return { selector: c.selector, omit: _.isBoolean(omit) ? omit : (c.omit || false) }
      })
    }
  }
  //************************************//
  _lastClickScroll = () => {
    const storageLastClickKey = getKeyFromSessionStorage(this.state.lastClickKey)
    const findRowData = _.find(this.state.data, item => `row-${item.id}` === storageLastClickKey)
    if (this.state.lastClickKey && storageLastClickKey && findRowData) {
      const scrollToTargetRow = () => {
        const tableBody = this.ref.current.querySelector('.rdt_TableBody')
        const lastClickRecord = tableBody.querySelector(`[role="row"][id="${storageLastClickKey}"]`)
        const tableHeaderHeight = 45
        tableBody.scrollTop = lastClickRecord.offsetTop - tableHeaderHeight
        removeKeyFromSessionStorage(this.state.lastClickKey)
      }
      if (this.state.treeView) {
        this._expandAllItemsInTreeView(scrollToTargetRow)
      } else {
        scrollToTargetRow()
      }
    }
  }
  //************************************//
  _setInitialFilter = (params) => {
    const sessionStorage = this.sessionStorage && this._getSessionStorageObject()
    if (this.props.history && this.props.history.location.search) {
      return { ...params.filter, ...params.forcedFilter }
    } else if (sessionStorage && sessionStorage.queryString) {
      return { ...params.filter, ...params.forcedFilter }
    } else {
      return { ...params.filter, ...params.defaultFilter, ...params.forcedFilter }
    }
  }
  //************************************//
  _getQueryString = () => {
    let queryString = ''
    const urlParams = fetchQueryStringFromUrl()
    if (this.state.isBrowserAction && !this.state.lastVisit && this.props.browserHistory && this.props.history) {
      queryString = urlParams
    } else if (!this.state.isBrowserAction && !this.state.lastVisit && this.props.browserHistory && this.props.history && urlParams) {
      queryString = urlParams
    } else {
      const sessionStorageObject = this._getSessionStorageObject()
      queryString = sessionStorageObject?.queryString
    }
    return queryString
  }
  _fetchKeysFromQueryString = () => {
    const queryString = this._getQueryString()
    return fetchKeysFromQueryString(
      queryString,
      ['limit', 'page', 'sort', `filter:${getFilterSelectors({ columns: this.state.columns, join: true })}`],
      customFetchKeysFromQueryStringCallbacks
    )
  }
  //************************************//
  _refresh = () => {
    const { clearSelectableRows } = this.state
    this.setState({
      disabled: true,
      allSelectedByFilter: false,
      clearSelectableRows: !clearSelectableRows,
      selectableRows: {}
    }, this._fetchData)
  }
  //************************************//
  _handlePagination = page => {
    const { clearSelectableRows } = this.state
    this.setState({
      page: page.selected + 1,
      disabled: true,
      allSelectedByFilter: false,
      clearSelectableRows: !clearSelectableRows,
      selectableRows: {}
    }, this._fetchData)
    //this._fetchData({page: page.selected + 1})
  }
  //************************************//
  _handleRowSelected = (selectableRows) => {
    const { bulkActions } = this.state
    if (bulkActions) {
      this.setState({
        selectableRows
      })
    }
  }
  //************************************//
  _clearSelections = () => {
    const { selectableRows, bulkActions, clearSelectableRows } = this.state
    if (bulkActions) {
      if (selectableRows.selectedCount > 0) {
        this.setState({
          allSelectedByFilter: false,
          clearSelectableRows: !clearSelectableRows,
          selectableRows: {}
        })
      }
    }
  }
  //************************************//
  _handleClickActionBarAllSelected = () => {
    this.setState({
      allSelectedByFilter: true
    })
  }
  //************************************//
  _handleClearActionBarAllSelected = () => {
    const { clearSelectableRows } = this.state
    this.setState({
      allSelectedByFilter: false,
      clearSelectableRows: !clearSelectableRows,
      selectableRows: {}
    })
  }
  //************************************//
  _getShowAllSelected = () => {
    const allSelected = this.state.selectableRows.allSelected
    const total = this.state.total
    const rowsCount = _.size(this.state.data)
    return this.state.bulkActionsByFilterEnabled && allSelected && total > rowsCount
  }
  //************************************//
  // ** Function to handle per page
  _handlePerPage = e => {
    const { clearSelectableRows } = this.state
    this.setState({
      limit: parseInt(e.target.value),
      disabled: true,
      allSelectedByFilter: false,
      clearSelectableRows: !clearSelectableRows,
      selectableRows: {}
    }, this._fetchData)
    //this._fetchData({limit: parseInt(e.target.value)})
  }
  //************************************//
  _onSort = (column, sortDirection) => {
    const { clearSelectableRows } = this.state
    this.setState(
      {
        disabled: true,
        sort: [{ key: _.replace(column.stringSelector, '.', '->'), direction: sortDirection }],
        allSelectedByFilter: false,
        clearSelectableRows: !clearSelectableRows,
        selectableRows: {}
      },
      this._fetchData
    )
  }
  //************************************//
  _onFilterReaction = (args) => {
    this.setState({
      dynamicFieldsVisibility: args?.dynamicFieldsVisibility ?? {}
    })
  }
  //************************************//
  _onFilter = (filter, state) => {
    const { clearSelectableRows } = this.state
    const mergedFilter = {
      ...filter,
      ...this.state.forcedFilter
    }
    const extraState = {}
    if (state?.dynamicFieldsVisibility) {
      extraState['dynamicFieldsVisibility'] = state?.dynamicFieldsVisibility
    }
    this.setState({
      filter: mergedFilter,
      filterFormData: {},
      disabled: true,
      isInitialFilter: false,
      allSelectedByFilter: false,
      clearSelectableRows: !clearSelectableRows,
      selectableRows: {},
      ...extraState
    }, this._fetchData)
  }
  //************************************//
  _onQueryChange = ({ key, name }, callback) => {
    const sessionStorageObject = this.state.sessionStorageObject
    const queries = _.get(sessionStorageObject, 'queries')

    // add query 
    if (!key) {
      const _key = key || `${uuidv4()}_Query`
      const queryString = this._getQueryString()
      saveQuery({
        key: _key,
        name,
        table_name: this.state.tableName,
        query_string: queryString
      }, ({ data }) => {
        sessionStorageObject.selected_key = _key
        sessionStorageObject.queries = { ...queries, [_key]: { id: data.id, key: _key, name, queryString } }
        this._setSessionStorageObject(sessionStorageObject)
        this.setState({
          sessionStorageObject
        }, this.init)
        callback()
      })
    }

    // rename query
    if (key) {
      const query = queries[key]
      saveQuery({
        id: query.id,
        key,
        name,
        table_name: this.state.tableName,
        query_string: query.queryString
      }, (res) => {
        sessionStorageObject.queries = { ...queries, [key]: { ...query, name } }
        this._setSessionStorageObject(sessionStorageObject)
        this.setState({
          sessionStorageObject: { ...sessionStorageObject }
        })
        callback()
      })
    }
  }
  //************************************//
  _onQuerySaveChange = ({ key }) => {
    const queryString = this._getQueryString()
    const sessionStorageObject = this.state.sessionStorageObject
    const queries = _.get(sessionStorageObject, 'queries')
    let query = _.get(queries, key)
    if (!query && key === 'default') {
      query = _.head(this.defaultQueries)
    }
    const { id, name } = query
    saveQuery({
      id,
      key,
      name,
      table_name: this.state.tableName,
      query_string: queryString
    }, ({ data }) => {
      sessionStorageObject.queries = { ...queries, [key]: { ...query, id: data.id, queryString } }
      this._setSessionStorageObject(sessionStorageObject)
      this.setState({
        sessionStorageObject
      })
    })
  }
  //************************************//
  _onQuerySelect = (key) => {
    if (_.get(this.state.sessionStorageObject, 'selected_key') !== key) {
      const sessionStorageObject = this.state.sessionStorageObject
      const queries = _.get(sessionStorageObject, 'queries')
      sessionStorageObject.selected_key = key
      sessionStorageObject.queryString = _.get(queries, `${key}.queryString`)
      this._setSessionStorageObject(sessionStorageObject)
      this.setState({
        disabled: true,
        isInitialFilter: false,
        sessionStorageObject
      }, this.init)
    }
  }
  //************************************//
  _onQueryDelete = ({ id, key }) => {
    const queries = _.get(this.state.sessionStorageObject, 'queries')
    const defaultQuery = _.get(this.state.sessionStorageObject, 'queries.default', _.head(this.defaultQueries))
    delete queries[key]
    const sessionStorageObject = { ...this.state.sessionStorageObject, queries, selected_key: defaultQuery.key, queryString: defaultQuery.queryString }
    const resCallback = () => {
      this._setSessionStorageObject(sessionStorageObject)
      this.setState({
        disabled: true,
        isInitialFilter: false,
        sessionStorageObject
      }, this.init)
    }
    deleteQuery(id, (res) => {
      resCallback()
    }, (res) => {
      if (res.data.error_code === "_OBJECT_NOT_FOUND") {
        resCallback()
      }
    })
  }
  //************************************//
  _filterMode = () => {
    const defaultFilterMode = this.state.defaultFilterMode
    const sessionFilterMode = getKeyFromSessionStorage(this.switchModeSessionStorageName)
    return sessionFilterMode || defaultFilterMode
  }
  //************************************//
  _onSwitch = (mode) => {
    if (this.switchModeSessionStorageName) {
      setKeySessionStorage(this.switchModeSessionStorageName, mode)
    }
  }
  //************************************//
  _onSelectColumnChange = (selectedColumns) => {
    const showHide = _.map(this.state.toolbar.showHide, (c) => {
      c.omit = !_.includes(selectedColumns, c.selector)
      return c
    })
    this.setState({
      toolbar: { ...this.state.toolbar, showHide }
    })
    if (this.showHideSessionStorageName) setKeySessionStorage(this.showHideSessionStorageName, JSON.stringify(showHide))
  }
  //************************************//
  _expandItemsInTreeView = (row) => {
    this.setState({
      data: this.state.data.map(x => {
        if (x.id === row.id) {
          return {
            ...x,
            expanded: !x.expanded
          }
        } else if (row.children.indexOf(x.id) > -1) {
          const attrs = {}
          if (x.children && !row.expanded) {
            attrs['expanded'] = false
          }
          return {
            ...x,
            hidden: row.expanded ? true : !(x.depth === row.depth + 1),
            ...attrs
          }
        } else {
          return x
        }
      })
    })
  }
  //************************************//
  _expandAllItemsInTreeView = (callback) => {
    let childrenArr = []
    this.setState({
      data: this.state.data.map(x => {
        if (x.children) {
          childrenArr = childrenArr.concat(x.children)
        }
        const attrs = {}
        attrs['expanded'] = !this.state.allExpanded
        if (childrenArr.indexOf(x.id) > -1) {
          attrs['hidden'] = this.state.allExpanded
        }
        return {
          ...x,
          ...attrs
        }
      }),
      allExpanded: !this.state.allExpanded
    }, () => {
      if (callback) callback()
    })
  }
  //************************************//
  toolbarRender = ({ columns }) => {
    return (
      <>
        <UncontrolledTooltip placement='top' target='react-dataTable-toggle-humanize-date'>
          {trans('gen.datatable.toolbar.humanized')}
        </UncontrolledTooltip>
        <Button id={'react-dataTable-toggle-humanize-date'} size={'sm'} color={this.state.humanizeDate ? 'flat-primary' : 'flat-secondary'} className={'btn-toolbar btn-toolbar-humanize'} onClick={() => this.setState({ humanizeDate: !this.state.humanizeDate })} disabled={this.state.progressPending}>
          <RegularCalendarRotateIcon svg={{ width: 16, height: 16 }} path={{ fill: 'currentColor' }} className='m-0' />
        </Button>
        {this.state.toolbar.canRefresh && (
          <>
            <UncontrolledTooltip placement='top' target='react-dataTable-toolbar-refresh'>
              {trans('gen.datatable.toolbar.refresh')}
            </UncontrolledTooltip>
            <Button id={'react-dataTable-toolbar-refresh'} size={'sm'} color={'flat-primary'} className={'btn-toolbar'} onClick={() => this._refresh()} disabled={this.state.progressPending} >
              <FontAwesomeIcon icon={RefreshIcon} className='m-0' />
            </Button>
          </>
        )}
        {this.state.toolbar.canChooseColumns && <SelectColumns key={this.state.columnsNumber} columns={columns} onChange={this._onSelectColumnChange} disabled={this.state.progressPending} />}
      </>
    )
  }
  //************************************//
  CustomPagination = () => {
    const { page, totalPages, total, limit, limitList } = { ...this.state }
    return (
      <Container fluid={true} className='custom-pagination font-weight-bolder'>
        <Row>
          <Col md={6} className='d-flex align-items-center justify-content-md-start justify-content-sm-center justify-content-xs-center py-50'>
            <Label className='pr-1 mb-0' for='sort-select'>{trans('gen.datatable.show')}</Label>
            <Input
              className='dataTable-select'
              type='select'
              id='sort-select'
              bsSize='sm'
              value={this.state.limit}
              onChange={e => this._handlePerPage(e)}
            >
              {_.map(limitList, (limit, index) => {
                return (
                  <option key={limit} value={limit}>{limit}</option>
                )
              })}
            </Input>
            <Label className='px-1 mb-0' >
              {trans('gen.datatable.totalRowsInfo', {
                from: ((page - 1) * limit) + 1,
                to: ((page - 1) * limit) + ((parseInt(limit) > total) ? total : (parseInt(limit))),
                total
              })
              }
            </Label>
          </Col>
          <Col md={6}>
            <ReactPaginate
              previousLabel={''}
              nextLabel={''}
              breakLabel='...'
              pageCount={totalPages || 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              activeClassName='active'
              forcePage={page !== 0 ? page - 1 : 0}
              onPageChange={page => this._handlePagination(page)}
              pageClassName={'page-item'}
              nextLinkClassName={'page-link'}
              nextClassName={'page-item next'}
              previousClassName={'page-item prev'}
              previousLinkClassName={'page-link'}
              pageLinkClassName={'page-link'}
              breakClassName='page-item'
              breakLinkClassName='page-link'
              containerClassName={
                'pagination react-paginate separated-pagination pagination-sm justify-content-md-end justify-content-sm-center justify-content-xs-center mb-0 py-50'
              }
            />
          </Col>
        </Row>
      </Container>
    )
  }
  //************************************//
  conditionalRowStyles() {
    let conditionalRowStyles = []
    if (this.state.treeView) {
      conditionalRowStyles = [conditionalHideRowForTreeView]
    }
    if (this.props.conditionalRowStyles) {
      conditionalRowStyles = [...conditionalRowStyles, ...this.props.conditionalRowStyles]
    }
    return conditionalRowStyles
  }
  //************************************//
  render() {
    const visibleColumns = _.map(this.state.columns, c => {
      const column = { ...c }
      const visible = this._checkDynamicFieldVisibility(column)
      const showHideObject = _.find(this.state.toolbar.showHide, (sc) => sc.selector === column.selector)
      column.visible = !visible
      column.selected = showHideObject ? showHideObject?.omit : column.omit
      column.omit = visible && showHideObject ? showHideObject?.omit : column.omit
      return column
    })
    return (
      <div ref={this.ref} className="react-dataTable-wrapper">
        {this.state.hasFilter && (
          <FilterForm
            savedQueries={{
              enabled: this.state.savedQueriesEnabled,
              defaultQueries: this.defaultQueries,
              data: this.state.sessionStorageObject
            }}
            filterFormData={this.state.filterFormData}
            forcedFilter={this.state.forcedFilter}
            hiddenFilter={this.state.hiddenFilter}
            defaultFilterMode={this._filterMode()}
            columns={this.state.columns}
            onFilterReaction={this._onFilterReaction}
            onFilter={this._onFilter}
            onQueryChange={this._onQueryChange}
            onQuerySaveChange={this._onQuerySaveChange}
            onQuerySelect={this._onQuerySelect}
            onQueryDelete={this._onQueryDelete}
            onSwitch={this._onSwitch}
            disabled={this.state.progressPending}
            lastVisit={this.state.lastVisit}
          />
        )}
        <Card>
          {this.state.toolbar && (
            <div className={'react-dataTable-toolbar'}>
              {this.toolbarRender({ columns: visibleColumns })}
            </div>
          )}
          <DataTableBasic
            noHeader
            striped
            pagination={this.state.pagination}
            paginationServer={!this.state.clientSideMode}
            sortServer={!this.state.clientSideMode}
            onSort={this._onSort}
            disabled={this.state.disabled}
            progressPending={this.state.progressPending}
            progressComponent={<Spinner color='primary' size='lg' className='p-2 m-2' />}
            noDataComponent={<NoDataFound noDataText={this.state.noDataText} createNewAction={this.state.createNewAction} total={this.state.total} applyFilter={this.state.filter} applyFilterFormData={this.state.filterFormData} />}
            className={`react-dataTable ${this.props.className || ''}`}
            columns={columns(visibleColumns, this.state, this._expandItemsInTreeView, this._expandAllItemsInTreeView, this._lastClickEvent)}
            paginationComponent={!this.state.clientSideMode ? this.CustomPagination : undefined}
            data={this.state.data}
            fixedHeader={true}
            fixedHeaderScrollHeight={'500px'}
            highlightOnHover={true}
            pointerOnHover={this.state.pointerOnHover}
            onRowClicked={this.props.onRowClicked ? this.props.onRowClicked : (row, event) => { }}
            onRowDoubleClicked={this.props.onRowDoubleClicked ? this.props.onRowDoubleClicked : (row, event) => { }}
            conditionalRowStyles={this.conditionalRowStyles()}
            paginationRowsPerPageOptions={this.state.limitList}
            paginationPerPage={50}
            selectableRows={this.props.selectableRows || !_.isNull(this.state.bulkActions)}
            clearSelectedRows={this.state.clearSelectableRows}
            onSelectedRowsChange={this.props.onSelectedRowsChange || this._handleRowSelected}
          />
          {this.state.bulkActions && this.state.selectableRows?.selectedCount > 0 && (
            <ActionBar
              ref={this._actionBarRef}
              onClose={this._clearSelections}
              numOfSelected={this.state.selectableRows?.selectedCount}
              showAllSelected={this._getShowAllSelected()}
              numOfAllSelected={this.state.total}
              onClickAllSelected={this._handleClickActionBarAllSelected}
              onClearAllSelected={this._handleClearActionBarAllSelected}
              initShow={true}
              container={'#root'}
              buttons={this.state.bulkActions({
                selected: this.state.selectableRows?.selectedRows,
                applyFilter: this.state.allSelectedByFilter,
                filter: this.state.filter,
                effectedRowsCount: this.state.allSelectedByFilter
                  ? this.state.total
                  : this.state.selectableRows?.selectedCount
              })}
            />
          )}
        </Card>
      </div>
    )
  }
}
//************************************//
const mapStateToProps = store => ({
  // loading: store.app.loading,
  settingSavedQueriesEnabled: store.app.settings.app.saved_queries_enabled,
  langArr: store.app.settings.app.langs
})
export default connect(mapStateToProps, null, null, { forwardRef: true })(DataTable)
